import React from 'react';

const CSS = require('./CardCornerFigure.module.scss');

interface CardCornerFigureProps {
  className: string;
  variant?:
    | 'pink-50'
    | 'pink'
    | 'purple'
    | 'orange'
    | 'error'
    | 'error-50'
    | 'warning'
    | 'warning-50'
    | 'light-gray'
    | 'lighter-gray';
}

function CardCornerFigure({
  className,
  variant = 'pink-50',
}: CardCornerFigureProps) {
  return (
    <svg width="165px" height="72px" viewBox="0 0 165 72" className={className}>
      <g>
        <path
          d="M-0.00455902759,72 L2.07965276e-05,0.00665185832 L164.995441,0 C101.716268,5.32807886 44.3968814,31.6528024 -0.00455902759,72 Z"
          className={CSS.CardCornerFigure}
          data-variant={variant}
        />
      </g>
    </svg>
  );
}

export default CardCornerFigure;
